import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./en.json";
import af from "./af.json";
import zu from "./zu.json";
import xh from "./xh.json";
import sw from "./sw.json";
import fr from "./fr.json";
import pt from "./pt.json";
import ar from "./ar.json";

export const SUPPORTED_LANGUAGES = [
    { code: "en", label: "English", flag: "🇬🇧" },
    { code: "af", label: "Afrikaans", flag: "🇿🇦" },
    { code: "zu", label: "isiZulu", flag: "🇿🇦" },
    { code: "xh", label: "Xhosa", flag: "🇿🇦" },
    { code: "sw", label: "Swahili", flag: "🇰🇪" },
    { code: "fr", label: "Français", flag: "🇫🇷" },
    { code: "pt", label: "Português", flag: "🇵🇹" },
    { code: "ar", label: "العربية", flag: "🇸🇦" },
];

export const RTL_LANGS = new Set(["ar"]);

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            af: { translation: af },
            zu: { translation: zu },
            xh: { translation: xh },
            sw: { translation: sw },
            fr: { translation: fr },
            pt: { translation: pt },
            ar: { translation: ar },
        },
        fallbackLng: "en",
        supportedLngs: ["en", "af", "zu", "xh", "sw", "fr", "pt", "ar"],
        nonExplicitSupportedLngs: true,
        load: "languageOnly",
        detection: {
            order: ["querystring", "localStorage", "navigator", "htmlTag"],
            caches: ["localStorage"],
            lookupQuerystring: "lang",
            lookupLocalStorage: "medx_lang",
        },
        interpolation: { escapeValue: false },
    });

// Apply RTL direction whenever language changes
const applyDir = (lng) => {
    document.documentElement.dir = RTL_LANGS.has(lng) ? "rtl" : "ltr";
    document.documentElement.lang = lng;
};
applyDir(i18n.language || "en");
i18n.on("languageChanged", applyDir);

export default i18n;
